import React from 'react';
import NavMenuLeaflet from './NavMenuLeaflet';
import NavMenuMega from './NavMenuMega';

export default class NavMenuApp extends React.Component {

    render() {
        return (
            <>
                <div className="d-md-none overflow-hidden"><NavMenuLeaflet navMenu={this.props.navMenu}/></div>
                <div className="d-none d-md-block overflow-hidden h-100"><NavMenuMega navMenu={this.props.navMenu}/></div>
            </>
        )
    }
}
